import { render, staticRenderFns } from "./PdfPreview.vue?vue&type=template&id=10d149b2&scoped=true"
import script from "./PdfPreview.vue?vue&type=script&lang=js"
export * from "./PdfPreview.vue?vue&type=script&lang=js"
import style0 from "./PdfPreview.vue?vue&type=style&index=0&id=10d149b2&prod&scoped=true&lang=scss"
import style1 from "./PdfPreview.vue?vue&type=style&index=1&id=10d149b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d149b2",
  null
  
)

export default component.exports